<template>
    <div id="cards-agency">
        <div id="cards" :class="{ sticky: this.$store.state.app.positionSticky }">
            <div class="cards" v-show="!this.$store.state.app.playVideoAgency || isMobile">
                <div class="card card-1" ref="card-1">
                    <div class="front">
                        <img src="@/assets/img/agency/cards_01.png" alt="" />
                    </div>
                    <div class="back">
                        <div>
                            <h1>
                                <div v-html="$t('message.page_agency.card_01.title')"></div>
                                <img src="@/assets/img/agency/underline_01.png" alt="" />
                            </h1>

                            <img src="@/assets/img/agency/card_back_01.png" alt="" />

                            <ul v-html="$t('message.page_agency.card_01.list')"></ul>

                            <!--<div class="link">
                                <span>{{ $t("message.page_agency.card_01.link") }}</span>
                                <img src="@/assets/img/agency/arrow.png" alt="" />
                            </div>-->
                        </div>
                    </div>
                </div>
                <div class="card card-2" ref="card-2">
                    <div class="front">
                        <img src="@/assets/img/agency/cards_02.png" alt="" />
                    </div>
                    <div class="back">
                        <a href="references">
                            <h1>
                                <div v-html="$t('message.page_agency.card_02.title')"></div>
                                <img src="@/assets/img/agency/underline_02.png" alt="" />
                            </h1>

                            <img src="@/assets/img/agency/card_back_02.png" alt="" />

                            <ul v-html="$t('message.page_agency.card_02.list')"></ul>

                            <div class="link">
                                <span>{{ $t("message.page_agency.card_02.link") }}</span>
                                <img src="@/assets/img/agency/arrow.png" alt="" />
                            </div>
                        </a>
                    </div>
                </div>
                <div class="card card-3" ref="card-3">
                    <div class="front">
                        <img src="@/assets/img/agency/cards_03.png" alt="" />
                    </div>
                    <div class="back">
                        <a href="/formavisa">
                            <h1>
                                <div v-html="$t('message.page_agency.card_03.title')"></div>
                                <img src="@/assets/img/agency/underline_03.png" alt="" />
                            </h1>

                            <img src="@/assets/img/agency/card_back_03.png" alt="" />

                            <ul v-html="$t('message.page_agency.card_03.list')"></ul>

                            <div class="link">
                                <span>{{ $t("message.page_agency.card_03.link") }}</span>
                                <img src="@/assets/img/agency/arrow.png" alt="" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CardsAgency",
    data() {
        return {
            local: "fr",
            scrollVal: 0,
            isMobile: false,
        };
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
        },
    },
    mounted() {
        let _this = this;

        /**
         * Ajout class si version mobile
         */
        window.addEventListener("resize", function (e) {
            _this.isItMobile();
        });
        this.isItMobile();

        /**
         * Scroll animation
         */
        const cardsContainer = document.getElementById("cards-agency");
        window.addEventListener("scroll", () => {
            const scrollY = window.scrollY;

            const cardsContainerRect = cardsContainer.getBoundingClientRect();

            const startScrollY = cardsContainerRect.top + window.scrollY;
            const endScrollY = startScrollY + cardsContainer.offsetHeight / 1.5;

            // Clamp scrollY between startScrollY and endScrollY
            const clampedScroll = Math.min(Math.max(scrollY, startScrollY), endScrollY);

            // Calculate percentage
            const progress = (clampedScroll - startScrollY) / (endScrollY - startScrollY);

            // Décalages si besoin
            const scrollRotateBlock = Math.max(progress - 0.1, 0);
            const scrollRotateBlockCenter = Math.max(progress - 0.2, 0);

            document.body.style.setProperty("--scroll", progress);
            document.body.style.setProperty("--scrollRotateBlock", scrollRotateBlock);
            document.body.style.setProperty("--scrollRotateBlockCenter", scrollRotateBlockCenter);
        });
    },
    methods: {
        isItMobile() {
            let windowWidth = window.innerWidth;
            if (windowWidth < 992) {
                this.isMobile = true;
            }
        },
    },
};
</script>

<style lang="scss">
#app #content {
    padding-top: 0;
}

#cards-agency {
    .card-1 {
        .back {
            h1 {
                span {
                    &:first-child {
                        color: #a278dd;
                    }
                }
            }
        }
    }

    .card-2 {
        .back {
            h1 {
                span {
                    &:first-child {
                        color: #f73e3e;
                    }
                }
            }
        }
    }

    .card-3 {
        .back {
            h1 {
                span {
                    &:first-child {
                        color: #5beffb;
                    }
                }
            }
        }
    }

    .back {
        li {
            margin-bottom: 1rem;

            @media (max-width: 992px) {
                margin-bottom: 0.5rem;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
#cards-agency {
    top: 0;
    z-index: 0;
    height: 250vh;
    padding: 0 2rem;
    box-sizing: border-box;

    #cards {
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;

        &.sticky {
            position: sticky;
        }

        > img {
            max-width: 1200px;
            width: 100%;
            aspect-ratio: 9/5.063;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: absolute;
            z-index: -1;
            border-radius: 30px;
            overflow: hidden;
            opacity: 0;
            animation: opacityImg 1s linear infinite;
            animation-play-state: paused;
            animation-delay: calc(var(--scrollOpacity) * -5s);
            animation-iteration-count: 1;
            animation-fill-mode: both;
        }

        > .cards {
            max-width: 1200px;
            width: 100%;
            aspect-ratio: 9/5.063;
            display: flex;
            justify-content: space-between;
            align-items: stretch;
            opacity: 1;
            animation: opacityCards 1s linear infinite;
            animation-play-state: paused;
            animation-delay: calc(var(--scrollOpacityCards) * -10s);
            animation-iteration-count: 1;
            animation-fill-mode: both;

            > div {
                width: 33%;
                height: 100%;
                animation: rotate 1s linear infinite;
                animation-play-state: paused;
                animation-delay: calc(var(--scroll) * -10s);
                animation-iteration-count: 1;
                animation-fill-mode: both;
                cursor: pointer;

                &:first-child {
                    cursor: default;
                }

                > div {
                    height: 100%;
                    width: 100%;
                    position: absolute;
                    top: 0;
                    right: 0;
                    left: 0;
                    bottom: 0;
                    border-radius: 30px;
                    overflow: hidden;

                    &.front {
                        font-size: 3rem;
                        font-weight: 700;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        box-sizing: border-box;
                        transform: perspective(900.901px);
                        background-color: #fff;
                        backface-visibility: hidden;

                        animation: scrollRotateFront 1s linear infinite;
                        animation-play-state: paused;
                        animation-delay: calc(var(--scrollRotateBlock) * -8s);
                        animation-iteration-count: 1;
                        animation-fill-mode: both;

                        img {
                            width: 100%;
                        }
                    }

                    &.back {
                        background: #221d3b;
                        transform: perspective(1123.6px) rotateY(-180deg);
                        backface-visibility: hidden;

                        animation: scrollRotateBack 1s linear infinite;

                        animation-play-state: paused;
                        animation-delay: calc(var(--scrollRotateBlock) * -8s);
                        animation-iteration-count: 1;
                        animation-fill-mode: both;

                        display: flex;
                        flex-direction: column;

                        max-width: 100%;
                        margin: auto;

                        > div,
                        > a {
                            flex: 1;
                            padding: 1.5rem;
                            box-sizing: border-box;
                            color: #fff;
                            display: flex;
                            flex-direction: column;
                            text-decoration: none;

                            h1 {
                                margin: 0;
                                text-transform: uppercase;
                                font-family: Oswald, sans-serif;
                                font-weight: 600;
                                display: flex;
                                flex-direction: column;
                                font-size: 2rem;

                                > div {
                                    display: flex;
                                    flex-direction: column;
                                }

                                img {
                                    align-self: flex-start;
                                    margin-top: 1rem;
                                }
                            }

                            > img {
                                margin: 2rem auto;
                                display: block;
                                width: 80%;
                            }

                            ul {
                                font-weight: 100;
                                font-size: 1.2rem;
                                margin: 0;
                                flex: 1;
                                padding-left: 1.5rem;
                            }

                            .link {
                                text-decoration: none;
                                display: flex;
                                align-items: baseline;
                                font-family: Oswald, sans-serif;
                                font-weight: 100;
                                color: #fff;
                                font-size: 1.4rem;

                                span {
                                    margin-right: 0.5rem;
                                    text-decoration: underline;
                                }
                            }
                        }
                    }
                }

                &:first-child {
                    transform: perspective(1123.6px) translate3d(5.4169em, 8.8338em, 0px) rotate(-17.6677deg) rotateY(17.6677deg) rotateX(4.4169deg);

                    .front {
                        background-color: #d78cfa;
                    }

                    .back {
                        background-size: cover;
                        background-position: left center;
                    }
                }

                &:nth-child(2) {
                    transform: perspective(1123.6px) translate3d(4.4169em, -1.8338em, 0px) rotate(8.8338deg) rotateY(-13.2507deg) rotateX(-2.6501deg);
                    z-index: 20;

                    .front {
                        animation-delay: calc(var(--scrollRotateBlockCenter) * -8s);
                        background-color: red;
                    }
                    .back {
                        animation-delay: calc(var(--scrollRotateBlockCenter) * -8s);
                        background-size: cover;
                        background-position: center center;
                    }
                }

                &:last-child {
                    transform: perspective(1123.6px) translate3d(-5.6501em, 5.4169em, 0px) rotate(20.2507deg) rotateY(-13.1662deg) rotateX(10.3499deg);

                    .front {
                        background-color: #646166;
                    }
                    .back {
                        background-size: cover;
                        background-position: right center;
                    }
                }
            }
        }
    }
}

// HEIGHT
@media (max-height: 800px) {
    #cards-agency #cards {
        > .cards {
            > div {
                &:nth-child(2) {
                    transform: perspective(1123.6px) translate3d(4.4169em, 3.1662em, 0px) rotate(8.8338deg) rotateY(-13.2507deg) rotateX(-2.6501deg);
                }
            }
        }
    }
}

@media (max-height: 700px) {
    #cards-agency {
        position: static;
        height: auto;
        padding: 0 1rem;

        #cards {
            position: static;
            height: auto;
            display: flex;
            flex-flow: column;
            width: 100%;
            margin: auto;

            > img {
                display: none;
            }

            > .cards {
                animation: none;
                flex-flow: row;
                aspect-ratio: auto;

                > div {
                    animation: none;
                    width: 33%;
                    margin: 1rem 0;
                    height: auto;

                    > div {
                        position: static;

                        &.front {
                            transform: none;
                            animation: none;
                            display: none;
                        }

                        &.back {
                            transform: none;
                            animation: none;
                            display: flex;
                            max-width: 600px;

                            > div,
                            > a {
                                padding: 2rem 1rem;

                                h1 {
                                    font-size: 1.3rem;

                                    div {
                                        display: block;
                                    }

                                    img {
                                        margin-top: 1rem;
                                    }
                                }

                                > img {
                                    margin: 2rem auto;
                                    width: 80%;
                                    max-width: 300px;
                                }

                                ul {
                                    font-size: 1rem;
                                    padding-left: 1rem;
                                    margin-bottom: 2rem;
                                }

                                .link {
                                    font-size: 1.1rem;

                                    span {
                                        margin-right: 0.5rem;
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                    }

                    &:first-child {
                        transform: perspective(1123.6px) translate3d(0em, 0em, 0px) rotate(0deg) rotateY(0deg) rotateX(0deg);
                    }

                    &:nth-child(2) {
                        transform: perspective(1123.6px) translate3d(0em, 0em, 0px) rotate(0deg) rotateY(0deg) rotateX(0deg);
                    }

                    &:last-child {
                        transform: perspective(1123.6px) translate3d(0em, 0em, 0px) rotate(0deg) rotateY(0deg) rotateX(0deg);
                    }
                }
            }
        }
    }
}

/*@media (max-height: 650px) {
    #cards {
        > .cards {
            > div {
                &:nth-child(2) {
                    transform: perspective(1123.6px) translate3d(4.4169em, 9.1662em, 0px) rotate(8.8338deg) rotateY(-13.2507deg) rotateX(-2.6501deg);
                }

                &:last-child {
                    transform: perspective(1123.6px) translate3d(-5.6501em, 8.4169em, 0px) rotate(20.2507deg) rotateY(-13.1662deg) rotateX(10.3499deg);
                }
            }
        }
    }
}*/

// WIDTH
@media (max-width: 1400px) {
    #cards-agency {
        #cards {
            > .cards {
                > div {
                    > div {
                        &.back {
                            > div,
                            > a {
                                padding: 1.5rem;

                                h1 {
                                    font-size: 1.7rem;

                                    img {
                                        margin-top: 1rem;
                                    }
                                }

                                > img {
                                    margin: 2rem auto;
                                    width: 80%;
                                }

                                ul {
                                    font-size: 1.1rem;
                                    padding-left: 1.5rem;
                                }

                                .link {
                                    font-size: 1.3rem;

                                    span {
                                        margin-right: 0.5rem;
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 1200px) {
    #cards-agency {
        #cards {
            > .cards {
                > div {
                    > div {
                        &.back {
                            > div,
                            > a {
                                padding: 1.5rem 1rem;

                                h1 {
                                    font-size: 1.5rem;

                                    div {
                                        display: block;
                                    }

                                    img {
                                        margin-top: 1rem;
                                    }
                                }

                                > img {
                                    margin: 2rem auto;
                                    //width: 60%;
                                }

                                ul {
                                    font-size: 1.1rem;
                                    padding-left: 1.5rem;
                                }

                                .link {
                                    font-size: 1.1rem;

                                    span {
                                        margin-right: 0.5rem;
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 1080px) {
    #cards-agency {
        #cards {
            > .cards {
                > div {
                    > div {
                        &.back {
                            > div,
                            > a {
                                padding: 1.5rem 1rem;

                                h1 {
                                    font-size: 1.5rem;

                                    div {
                                        display: block;
                                    }

                                    img {
                                        margin-top: 0.5rem;
                                    }
                                }

                                > img {
                                    margin: 1rem auto;
                                    width: 60%;
                                }

                                ul {
                                    font-size: 1.1rem;
                                    padding-left: 1rem;
                                }

                                .link {
                                    font-size: 1.1rem;

                                    span {
                                        margin-right: 0.5rem;
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 992px) {
    #cards-agency {
        #cards {
            > .cards {
                > div {
                    > div {
                        &.back {
                            > div,
                            > a {
                                padding: 1rem;

                                h1 {
                                    font-size: 1.3rem;

                                    div {
                                        display: block;
                                    }

                                    img {
                                        margin-top: 0.5rem;
                                    }
                                }

                                > img {
                                    margin: 1rem auto;
                                    width: 60%;
                                }

                                ul {
                                    font-size: 1rem;
                                    padding-left: 1rem;
                                }

                                .link {
                                    font-size: 1.1rem;

                                    span {
                                        margin-right: 0.5rem;
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 855px) {
    #cards-agency {
        position: static;
        height: auto;
        padding: 0 1rem;

        #cards {
            position: static;
            height: auto;
            display: flex;
            flex-flow: column;
            //max-width: 580px;
            width: 100%;
            margin: auto;

            > img {
                display: none;
            }

            > .cards {
                animation: none;
                flex-flow: column;
                aspect-ratio: auto;

                > div {
                    animation: none;
                    width: 100%;
                    margin: 1rem 0;

                    > div {
                        position: static;

                        &.front {
                            transform: none;
                            animation: none;
                            display: none;
                        }

                        &.back {
                            transform: none;
                            animation: none;
                            display: flex;
                            max-width: 450px;

                            > div,
                            > a {
                                padding: 2rem 1rem;

                                h1 {
                                    font-size: 1.3rem;

                                    div {
                                        display: block;
                                    }

                                    img {
                                        margin-top: 1rem;
                                    }
                                }

                                > img {
                                    margin: 2rem auto;
                                    width: 80%;
                                    max-width: 300px;
                                }

                                ul {
                                    font-size: 1rem;
                                    padding-left: 1rem;
                                    margin-bottom: 2rem;
                                }

                                .link {
                                    font-size: 1.1rem;

                                    span {
                                        margin-right: 0.5rem;
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                    }

                    &:first-child {
                        transform: perspective(1123.6px) translate3d(0em, 0em, 0px) rotate(0deg) rotateY(0deg) rotateX(0deg);
                    }

                    &:nth-child(2) {
                        transform: perspective(1123.6px) translate3d(0em, 0em, 0px) rotate(0deg) rotateY(0deg) rotateX(0deg);
                    }

                    &:last-child {
                        transform: perspective(1123.6px) translate3d(0em, 0em, 0px) rotate(0deg) rotateY(0deg) rotateX(0deg);
                    }
                }
            }
        }
    }
}

@media (max-width: 576px) {
}

/**
KEYFRAMES
*/
@keyframes rotate {
    to {
        transform: perspective(1123.6px) translate3d(0em, 0em, 0px) rotate(0deg) rotateY(0deg) rotateX(0deg);
    }
}
@keyframes scrollRotateFront {
    to {
        transform: perspective(900.901px) rotateY(180deg);
    }
}
@keyframes scrollRotateBack {
    to {
        transform: perspective(1123.6px);
    }
}
@keyframes opacityImg {
    to {
        opacity: 1;
    }
}
@keyframes btnPlay {
    to {
        opacity: 1;
    }
}
@keyframes opacityCards {
    to {
        opacity: 0;
    }
}
@keyframes opacityVideo {
    to {
        opacity: 1;
    }
}
</style>
